export default "__VITE_ASSET__DrZ9LTqA__"